
export default {
  routes: [{
    path: '/video/list',
    name: 'video_list',
    component: () => import('@/module/video/videoList.vue'),
    meta: {
      title: '视频课列表',
      keepAlive: false,
      logined: true
    }
  },{
    path: '/video/detail',
    name: 'video_detail',
    component: () => import('@/module/video/videoDetail.vue'),
    meta: {
      title: '视频课详情',
      keepAlive: false,
      logined: true
    }
  }
  ]
}



// WEBPACK FOOTER //
// ./src/router/video.js